.markdown h1 { font-size: 32px; margin-top: 20px; margin-bottom: 12px; font-family: Inter-Bold; }
.markdown h2 { font-size: 24px; margin-top: 18px; margin-bottom: 10px; font-family: Inter-Bold; }
.markdown h3 { font-size: 20px; margin-top: 16px; margin-bottom: 8px; font-family: Inter-SemiBold; }
.markdown p { font-size: 16px; line-height: 24px; margin-bottom: 12px; font-family: Inter-Regular; }
.markdown ul { margin-bottom: 12px; padding-left: 22px; }
.markdown ol { margin-bottom: 12px; padding-left: 22px; }
.markdown li { font-size: 16px; line-height: 24px; font-family: Inter-Regular; }
